var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowNButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "137px",
    height: "88px",
    viewBox: "0 0 137 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arrow &amp; Button ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_09_ASSIST_Lenkstockhebel_Hinweis",
    transform: "translate(-1032.000000, -605.000000)",
    fill: "#00B0F4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow-&-Button",
    transform: "translate(1032.000000, 605.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.16635,54.0033109 C27.6502573,54.2409386 25,54.4612763 25,58.1823346 C25,61.903393 27.4453389,67.5587402 31.2191945,68.9108664 C33.7350981,69.812284 36.9953666,70.1541602 41,69.9364952 C38.1199041,59.1590299 35.1753541,53.8479684 32.16635,54.0033109 Z",
    id: "Button"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Arrow",
    points: "0 44 12.89 56.89 0 69.78"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowNButton);
export default __webpack_public_path__ + "static/media/icon-arrow_n_button.2b071a9287f29b0a6b87f0c0c0650b20.svg";
export { ForwardRef as ReactComponent };